<template>
  <table :style="{ width: width }">
    <tr v-for="r in 5" :key="'r' + r">
      <td
        v-for="i in 6"
        :key="i"
        class="hand"
        style="border:1px solid #dddddd;height:15px"
        :style="{ backgroundColor: colors[i + (r - 1) * 6 - 1] }"
        @click="$emit('select', colors[i + (r - 1) * 6 - 1])"
      ></td>
    </tr>
    <tr>
      <td class="text-center ui-text" colspan="6">{{ title }}</td>
    </tr>
  </table>

  <!-- <div style="width:100%">
    <div class="color-container" style="width:100%;border:1px solid #aaaaaa">
      <div
        v-for="color in colors"
        :key="color"
        class="color"
        :style="{ backgroundColor: color }"
        @click="$emit('select',color)"
        style="width:6.25%;padding:1px;display: inline-block;
  cursor: pointer;"
      >
        <div style="width:100%;padding-top:100%"></div>
      </div>
    </div>
    <div class="text-center">{{title}}</div>
  </div>-->
</template>

<script>
const colorsStr = `#ffffff
#ffeca1
#cce29e
#a3bfd9
#f0b9d5
#f7941d
#ece5d3
#fee361
#8dc63f
#4899c3
#d765a6
#f15831
#b5ad9a
#b19b32
#809778
#6b8799
#a54f65
#dd273e
#5e5959
#988b4a
#6d7f31
#2b76a2
#9b2541
#be1e2d
#231f20
#685f3a
#55725a
#007188
#89325f
#6d0f2a
`;
// const colorsStr = `#696969
// #bada55
// #7fe5f0
// #ff80ed
// #407294
// #cbcba9
// #420420
// #133337
// #065535
// #c0c0c0
// #5ac18e
// #666666
// #dcedc1
// #f7347a
// #576675
// #ffc0cb
// #ffe4e1
// #696966
// #008080
// #ffd700
// #e6e6fa
// #ffa500
// #ff7373
// #00ffff
// #40e0d0
// #d3ffce
// #0000ff
// #f0f8ff
// #b0e0e6
// #c6e2ff
// #003366
// #faebd7
// #ffff00
// #fa8072
// #7fffd4
// #ffb6c1
// #800000
// #eeeeee
// #00ff00
// #800080
// #fff68f
// #cccccc
// #c39797
// #ffc3a0
// #f08080
// #333333
// #20b2aa
// #66cdaa
// #ff6666
// #4ca3dd
// #ff00ff
// #ffdab9
// #ff7f50
// #468499
// #f6546a
// #afeeee
// #008000
// #c0d6e4
// #00ced1
// #660066
// #0e2f44
// #cbbeb5
// #088da5
// #990000
// #b4eeb4
// #daa520
// #b6fcd5
// #101010
// #808080
// #8b0000
// #f5f5f5
// #6897bb
// #ffff66
// #f5f5dc
// #81d8d0
// #ff4040
// #8a2be2
// #dddddd
// #66cccc
// #794044`;
const colors = colorsStr.split(/\s/g);
// console.log(colors.length);
export default {
  props: {
    title: {
      type: String
    },
    width: {
      type: String,
      default: "100%"
    }
  },
  data() {
    return { colors: colors };
  }
};
</script>

<style scoped>
/* .color {
  width: 6.25%;
  padding-top: 100%;
  display: inline-block;
  cursor: pointer;
  margin: 1px;
}
.color-container {
  border: 1px solid #aaaaaa;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
} */
</style>
